import { selectActiveForce, useForceStore } from "@/store/forceStore";
import { ElementCard } from "./ElementCard";
import { VehicleCard } from "./VehicleCard";

export function ForceList() {
	const force = useForceStore(selectActiveForce);

	if (!force) return null;

	const elements = force.elements;
	const vehicles = force.vehicles;

	if (elements.length === 0 && vehicles.length === 0) {
		return (
			<div className="flex flex-col items-center justify-center h-full text-text-muted py-12 lg:py-20 px-4">
				<div className="text-lg font-medium mb-2">No elements yet</div>
				<div className="text-sm text-center">
					<span className="hidden lg:inline">Select a faction and add elements from the sidebar</span>
					<span className="lg:hidden">Tap the menu icon to open the sidebar and add elements</span>
				</div>
			</div>
		);
	}

	return (
		<div className="space-y-3 pb-16 lg:pb-0">
			{elements.map((element) => (
				<ElementCard key={element.id} element={element} />
			))}
			{vehicles.length > 0 && (
				<>
					<h2 className="text-xs font-semibold text-text-muted uppercase tracking-wider pt-2">
						Vehicles
					</h2>
					{vehicles.map((vehicle) => (
						<VehicleCard key={vehicle.id} vehicle={vehicle} />
					))}
				</>
			)}
		</div>
	);
}
